var HomeWorkModule = (function () {
    function HomeWorkModule() {
    }
    return HomeWorkModule;
}());
export { HomeWorkModule };



// WEBPACK FOOTER //
// ./src/app/app-home-work/home-work.module.ts.pre-build-optimizer.js